import { LeagueStandings } from '../components/LeagueStandings.tsx';

/** The mini-league standings screen's own route (T-054) — behind auth like
 * `/tracker` and `/compare`: a signed-in manager sees their leagues (or the
 * explanation for having none yet), a signed-out visitor gets the landing
 * page instead, same as those two routes. */
export function LeaguesRoute() {
  return <LeagueStandings />;
}
